import Cookies from 'js-cookie'

const TokenKey = 'token'
const AccessTokenKey = 'accessToken'
const QuickTokenKey = 'quickAccessToken'

const ExpiresInKey = 'Admin-Expires-In'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}

export function getAccessToken() {
  return sessionStorage.getItem(AccessTokenKey);
}
export function setAccessToken(token) {
  return sessionStorage.setItem(AccessTokenKey, token);
}
export function removeAccessToken() {
  return sessionStorage.removeItem(AccessTokenKey);
}

//////////////
export function setQuickToken(token) {
  return sessionStorage.setItem(QuickTokenKey, token);
}
export function getQuickToken() {
  return sessionStorage.getItem(QuickTokenKey);
}
export function removeQuickToken() {
  return sessionStorage.removeItem(QuickTokenKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js